import { ProductSection } from "./ProductSection";

export function ShopPage() {
  return (
    <main className="min-h-screen">
      <ProductSection />
    </main>
  );
}
